// extracted by mini-css-extract-plugin
export default {"miniNav":"Dashboard_miniNav__t8L4t"};